import React from 'react';
import {
  Button, Modal, Spinner,
} from 'react-bootstrap';
import classNames from './ConfirmModal.module.scss';

export function ConfirmModal({
  children,
  isLoading,
  title,
  confirmButtonTitle = 'Confirm',
  cancelButtonTitle = 'Cancel',
  isConfirmButtonDisabled = false,
  onConfirm,
  onCancel,
  ...otherProps
}) {
  return (
    <Modal
      {...otherProps}
    >
      <Modal.Header className={classNames.header}>
        <Modal.Title className={classNames.title}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={classNames.body}>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            type="button"
            variant="secondary"
            className={classNames.button}
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelButtonTitle}
          </Button>
          <Button
            type="button"
            variant="primary"
            className={classNames.button}
            onClick={onConfirm}
            disabled={isConfirmButtonDisabled || isLoading}
          >
            {isLoading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            )}
            {confirmButtonTitle}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
